<template>
  <div :class="['container-style']">
    <div v-if="type === 'horizontal'" class="d-flex" style="gap: 16px;">
      <v-btn
        v-for="(item, index) in horizontalValues"
        :key="index"
        x-small 
        fab 
        color="transparent" 
        class="elevation-0" 
        @click="handleSelectHorizontal(item.value)"
      >
        <v-icon size="18" :color="horizontal === item.value ? 'bt_color' : 'grey'">
          {{horizontal === item.value ? 'fa-regular': 'fa-light'}} {{item.icon}}
        </v-icon>
      </v-btn>
    </div>

    <div v-if="type === 'vertical'" class="d-flex" style="gap: 16px">
      <v-btn
        v-for="(item, index) in verticalValues"
        :key="index"
        x-small 
        fab 
        color="transparent" 
        class="elevation-0" 
        @click="handleSelectVertical(item.value)"
      >
        <v-icon size="18" :color="vertical === item.value ? 'bt_color' : 'grey'">
          {{vertical === item.value ? 'fa-regular': 'fa-light'}} {{item.icon}}
        </v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>

export default {
  name: 'SectionAlignment',
  props: {
    value: {type: Object, required: true},
    type: {type: String, default: 'horizontal'}, // horizontal or vertical
    keyValue: {type: String}
  },

  computed: {
    alignment: {
      get () { return this.value },
      set (v) { 
        this.$emit('input', v)
      }
    },

    horizontal () {
      return this.alignment['text-position']
    },

    vertical () {
      return this.alignment['text-position-vertical'] || ''
    }    
  },

  data: () => ({
    horizontalValues: [
      {icon: 'fa-objects-align-left', value: 'left'},
      {icon: 'fa-objects-align-center-horizontal', value: 'center'},
      {icon: 'fa-objects-align-right', value: 'right'}
    ],
    verticalValues: [
      {icon: 'fa-objects-align-top', value: 'start'},
      {icon: 'fa-objects-align-center-vertical', value: 'center'},
      {icon: 'fa-objects-align-bottom', value: 'end'}
    ],
  }),

  methods: {
    handleSelectHorizontal (value) {
      this.alignment['text-position'] = value
    },

    handleSelectVertical (value) {
      this.alignment['text-position-vertical'] = value
    }
  }
}
</script>

<style scoped>
.container-style {
  display: flex;
  height: 40px;
  justify-content: center;
  align-items: center;
  gap: 16px;
  border-radius: 8px;
  background-color: #F6F7F7;
  cursor: pointer;
  border: #EDEDF1 1px solid !important;
}
</style>
